import axios from 'axios';
import $ from 'jquery';

/**
 * 处理返回错误信息
 * @param  {String} errStat [错误类型]
 * @param  {String} filter  [错误处理方式]
 * @param  {String} toPage  [要返回的页面]
 * @return {[type]}         [description]
 */
function doError(errStat = "", filter = "", toPage = "") {
//   if (status < 300) {
//     return;
//   }
//   if (jump) { //进行特殊字符判断处理
//     if ($(".z-loadingPanel")) {
//       $(".z-loadingPanel").remove();
//     }
//     return;
//   }
    
  if(filter == "default"){
    if($(".z-loadingPanel")){
      $(".z-loadingPanel").remove();
    }
    window.location.href = "/public/home/login?r=" + toPage;
  }else if(filter == "author"){
    if(errStat == "Er401"){
      let href = encodeURIComponent(location.href);
      location.replace("/public/home/401?toPage="+href);
    }else if(errStat == "Er403"){
      location.replace("/public/home/403");
    }
  }else if(filter == "report"){
    if(errStat == "Er401"){
      let href = encodeURIComponent(location.href);
      location.replace("/public/home/401?toPage="+href);
    }
  }
}

export default async(url = '', data = {}, type = 'GET',filter="default") => {
  if(!url){
    throw new Error("url不能为空");
  }

  let headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }

  let reg = /\w+\?\w+/;
  if(reg.test(url)){
    url += "&meno=web";
  }else{
    url += "?meno=web";
  }


  if(data instanceof FormData){
    type = "POST";
    headers['Content-Type'] = "application/x-www-form-urlencoded";
  }else{
    let names = Object.getOwnPropertyNames(data);
    if(names.length>0){
      type = "POST";
    }
  }

  if(type == "GET"){
    let radom = Math.random();
    url += `&radom=${radom}`
  }

  let response = new Promise(()=>{});

  try{
    response = await axios({
      method: type,
      url: url,
      data:data,
      headers: headers,
      cache: false
    });

    if(response.data && !response.data.ok && (response.data.ern == "Er401" || response.data.ern == "Er403")){
      let pathname = location.pathname;
      let search = location.search;
      let r = encodeURIComponent(pathname + search);
      doError(response.data.ern,filter,r);
      //window.location.href = "/public/home/login?r=" + r;
    }else if(response.data && !response.data.ok && response.data.ern == "Er404"){
      //window.location.href = "public/home/404";
    }
  } catch (error) {
    if (error.response) {
      if(error.response.data && !error.response.data.ok && (error.response.data.ern == 'Er401' || error.response.data.ern == 'Er403')){
        //去登录页面
        var r = error.response.data.err.match(/\/login(?:.html)?\?r=(\S*)/);
        if(r && r.length){
          r = r[1];
        }else{
          r = encodeURIComponent('/public/home/index');
        }

        doError(error.response.data.ern, filter, r);
        //window.location.href = "/public/home/login?r=" + r;
      }else if(error.response.data && !error.response.data.ok && error.response.data.ern == "Er404"){
        //window.location.href = "public/home/404";
      }else{
        response = new Promise(function (resolve,reject) {
          resolve(error.response)
        });
      }
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log('Error', error.message);
    }
      
    if (filter == 'report') { //特殊参数处理返回错误信息
        return error.response
    }
  }

  return response;
}



// WEBPACK FOOTER //
// ./src/config/axios.js